import { formatCurrency } from "@/number_format";

import { PRICES } from "./values";

export const quantiquestAnwaltNextContactValidation = (
  contact: ContactFull,
  lastCallContact: Nilable<ContactRefType>,
  _questionnaire: Nullable<CCTaskType>,
  _events: EventDetailWoContact[],
): [boolean, string] => {
  if (contact.id === lastCallContact?.id) {
    return [true, ""];
  }

  const allowedStates = ["Wiedervorlage", "Paket gebucht", "nicht interessiert", "nicht erreichbar"];

  if (contact.status && allowedStates.includes(contact.status.name)) {
    return [true, ""];
  }

  const toolTipText =
    "Bitte rufen Sie diesen Kontakt erst an oder setzen Sie ihn auf eine der folgenden Statusmöglichkeiten: „Wiedervorlage“, „Paket gebucht“, „nicht interessiert“, „nicht erreichbar“";

  return [false, toolTipText];
};

export const getPaymentMethods = (lawFirm: "Wirtschaftskanzlei" | "Privatkanzlei", discounted: boolean) => {
  let oneOffPaymentPrice = PRICES[lawFirm]!["Einmalzahlung"]!;

  if (discounted) {
    oneOffPaymentPrice *= 0.9;
  }

  if (lawFirm === "Wirtschaftskanzlei") {
    return [
      { label: `Einmalzahlung (${formatCurrency(oneOffPaymentPrice)})`, value: "Einmalzahlung" },
      { label: "kein Interesse", value: "kein Interesse" },
    ];
  }

  return [
    { label: `Einmalzahlung (${formatCurrency(oneOffPaymentPrice)})`, value: "Einmalzahlung" },
    {
      label: `monatliche Zahlung (${formatCurrency(PRICES[lawFirm]!["monatliche Zahlung"]!)} monatlich)`,
      value: "monatliche Zahlung",
    },
    { label: "kein Interesse", value: "kein Interesse" },
  ];
};
